/* eslint-disable @typescript-eslint/no-explicit-any */
function encode(param) {
    return param === undefined ? '' : encodeURIComponent(param);
}
export function url(strings, ...params) {
    return strings.reduce((acc, str, i) => `${acc}${str}${encode(params[i])}`, '');
}
//# sourceMappingURL=url.js.map